module.exports = __webpack_public_path__ + "img/TSH.c76d9f52.svg";